'use client'

import NextLink from 'next/link'
import { usePathname } from 'next/navigation'
import { twMerge } from 'tailwind-merge'
import { infoPages, pages } from '@/settings'

export function Nav() {
  const pathname = usePathname()

  const renderNavItem = ({ name, href }: { name: string; href: string }) => {
    const isActive = pathname === href
    return (
      <li key={href}>
        <NextLink hrefLang='en' href={href} aria-label={name} className={twMerge('nav-item', isActive && 'active')}>
          {name}
        </NextLink>
      </li>
    )
  }

  return (
    <nav className='side-nav' aria-labelledby='about-us-nav-heading'>
      <div id='about-us-nav-heading' className='pb-3! text-xl! font-bold'>
        Information
      </div>
      <ul className='btn-group'>
        {infoPages.map(renderNavItem)}
        {renderNavItem({ name: pages.forDealers.name, href: pages.forDealers.href })}
      </ul>
    </nav>
  )
}
